// frontend/src/components/Logo.js
import React from 'react';
import { Link } from 'react-router-dom';

const Logo = () => {
  return (
    <Link to="/" className="group flex items-center space-x-2 hover:opacity-90 transition-opacity">
      <div className="relative w-8 h-8">
        <svg 
          className="w-full h-full" 
          viewBox="0 0 48 48" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
        >
          <path 
            d="M24 6C14.0589 6 6 14.0589 6 24C6 33.9411 14.0589 42 24 42C33.9411 42 42 33.9411 42 24C42 14.0589 33.9411 6 24 6Z" 
            fill="url(#paint0_linear)" 
          />
          <path 
            d="M16 22C16 22 18 18 24 18C30 18 32 22 32 22" 
            stroke="white" 
            strokeWidth="2" 
            strokeLinecap="round"
          />
          <path 
            d="M16 26C16 26 18 30 24 30C30 30 32 26 32 26" 
            stroke="white" 
            strokeWidth="2" 
            strokeLinecap="round"
          />
          <defs>
            <linearGradient 
              id="paint0_linear" 
              x1="24" 
              y1="6" 
              x2="24" 
              y2="42" 
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#7C3AED"/>  {/* purple-600 */}
              <stop offset="1" stopColor="#3B82F6"/>  {/* blue-500 */}
            </linearGradient>
          </defs>
        </svg>
      </div>
      <span className="text-2xl font-bold bg-gradient-to-r from-purple-600 to-blue-500 bg-clip-text text-transparent">
        MealPlanner
      </span>
    </Link>
  );
};

export default Logo;